import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import { SiteSettingsProvider } from "./site/SiteSettingsContext";
import { DarkModeProvider } from "./site/DarkModeContext";

function AppShell() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen flex flex-col">
      {!isAdminRoute && <Navbar />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <DarkModeProvider>
        <SiteSettingsProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppShell />
          </BrowserRouter>
        </SiteSettingsProvider>
      </DarkModeProvider>
    </I18nextProvider>
  );
}

export default App;
